<template>

  <!--<div class="worder-summary-top">-->
    <!--<div class="worder-summary-top-left">-->
      <!--<div class="worder-summary-top-left-item">-->
        <!--<span class="label">业务板块</span>-->
        <!--<span class="val">{{customRender(model.businessSegment,'business_segment')}}</span>-->
      <!--</div>-->
      <!--<div class="worder-summary-top-left-item">-->
        <!--<span class="label">操作类型</span>-->
        <!--<span class="val">{{model.typeName}}</span>-->
      <!--</div>-->
      <!--<div class="worder-summary-top-left-item" v-if="model.backType && !model.backFlag">-->
        <!--<span class="label">回收倒计时</span>-->
        <!--<span class="val">{{djs}}</span>-->
      <!--</div>-->
      <!--<div class="worder-summary-top-left-item">-->
        <!--<span class="label">累计时长</span>-->
        <!--<span class="val">{{ljsc}}</span>-->
      <!--</div>-->
      <!--<div class="worder-summary-top-left-item">-->
        <!--<span class="time">{{statusMap[model.workOrderStatus]}}</span>-->
      <!--</div>-->
    <!--</div>-->
  <!--</div>-->

  <div class="order-top-box">
    <div>
      <span class="left-bx">业务板块：</span>
      <span class="right-bx"><img :src="model.logo" v-if="model.logo"/>{{customRender(model.businessSegment,'business_segment')}}</span>
    </div>
    <div>
      <span class="left-bx">工单类型：</span>
      <span class="right-bx">{{model.typeName}}</span>
    </div>
    <div>
      <span class="left-bx">工单状态：</span>
      <span class="right-bx">{{statusMap[model.workOrderStatus]}}</span>
    </div>
  </div>
</template>

<script>
  import { httpAction, getAction,getFileAccessHttpUrl ,deleteAction} from '@/api/manage'
  import {initDictOptions, filterDictText} from '@/components/dict/JDictSelectUtil'
  import { returnCallTimeEng ,returnCallTime,formatDate} from '@/utils/util'
  export default {
    name: 'WorkOrderInfo',
    props: {
      model:{
        type:Object,
        default:{}
      },
      dictOptions:{
        type:Object,
        default:{}
      }
    },data(){
      return {
        returnCallTimeEng:returnCallTimeEng,
        returnCallTime:returnCallTime
       ,statusMap:{
          1:"进行中",
          2:"已结束",
          4:"进行中"
        },
        ljsc:'',
        djs:''
      }
    },methods:{
      customRender(text,dict){
        //字典值替换通用方法
        return filterDictText(this.dictOptions[dict], text);
      },getLjsc(){
        this.ljsc = this.returnCallTime(this.model.createTime,null);
        if(this.model.backType && !this.model.backFlag){

          this.djs = this.returnCallTime(formatDate(Date.now(),"yyyy-MM-dd hh:mm:ss"),this.model.backTime);
          if(this.djs=="0秒"){
            this.reloadInfo();
          }
        }
        let that = this;
        setTimeout(function(){
          that.getLjsc();
        },1000);
      },reloadInfo(){
         this.$emit("load",1);
      }

    }
  }
</script>
<style lang="less" scoped>

  .order-top-box{
    display: flex;
    align-items: center;
    height: 56px;
    border-bottom: 1px solid #e6edf5;
    gap: 50px;
    padding-left: 24px;
  }

  .order-top-box div .left-bx{
      color: #7D8592;
    font-size: 16px;
  }
  .order-top-box div .right-bx{
    font-size: 16px;
  }
  .order-top-box div .right-bx img{
    width: 24px;
    height: 24px;
    border-radius: 3px;
    margin: 0 10px;
  }

  .worder-summary-top{
     display: flex;
     align-items: center;
     justify-content: space-between;
     padding-right:24px;
     height: 100px;
     border-bottom: 1px solid #e6edf5;
   }
  .worder-summary-top .worder-summary-top-left{
    flex: 1;
    display:flex;
    align-items: center;
  }
  .worder-summary-top .worder-summary-top-left .worder-summary-top-left-item{
    flex:1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
  }
  .worder-summary-top-left-item .label{
    color: rgba(145, 146, 158, 1);
    font-size: 16px;
  }
  .worder-summary-top-left-item .val{
    color:rgba(10, 22, 41, 1);
    font-size: 16px;
  }
  .worder-summary-top-left-item img{
    width: 16px;
    height: 16px;
    margin-left: 30px;
  }
  .worder-summary-top-left-item .time{
    /*font-size: 12px;*/
    /*font-weight: 400;*/
    color: rgba(63, 140, 255, 1);
    font-size: 16px;
  }

  /deep/ .ant-select-focused .ant-select-selection, .ant-select-selection:focus, .ant-select-selection:active{
    -webkit-box-shadow:unset !important;
    box-shadow:unset !important;
  }

</style>